module.exports = __webpack_public_path__ + "_/img/MapMarker8_Red.60ad7f72.svg";